import React from 'react';
import classNames from 'classnames';

import css from './IconCamping.module.css';

export const IconCamping = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
      <title />
      <path d="m13.083 6.167.846-1.41a.5.5 0 0 0-.858-.514L12.5 5.2l-.571-.952a.5.5 0 1 0-.858.514l.846 1.41-7.733 12.884A1.284 1.284 0 0 0 5.283 21h14.434a1.284 1.284 0 0 0 1.1-1.942Zm-8.042 13.4L12 7.972V14.5A5.506 5.506 0 0 1 6.5 20H5.283a.283.283 0 0 1-.242-.429ZM12 17.948V20H9.948A6.526 6.526 0 0 0 12 17.948ZM19.717 20H13V7.972l6.96 11.6a.283.283 0 0 1-.243.428Z" />
    </svg>
  );
};

export default IconCamping;
